const ReviewModel = {
  applicants: ["hasMany", "applicant"],
}

export default ReviewModel
